import Search from "./search";
import SearchResults from "./search-results";

export {
    SearchResults
}

export default Search;